export default "__VITE_ASSET__Djgs_Zi3__"